module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0114.jpg?v=17feb631";